import { defineMessages } from 'react-intl';

/**
 * Translated subdivision-type labels.
 * Each entry is the plain English term for that administrative division type.
 */
export const subdivisionLabelMessages = defineMessages({
  atoll: {
    defaultMessage: 'Atoll',
    id: 'WZtR2TiK8G',
    description: 'Subdivision label: atoll (e.g. Maldives)',
  },
  atollIsland: {
    defaultMessage: 'Atoll / Island',
    id: 'D3n5x+mXuF',
    description: 'Subdivision label: atoll or island (e.g. Marshall Islands)',
  },
  autonomousCommunity: {
    defaultMessage: 'Autonomous Community',
    id: '/6gaIsIJtY',
    description: 'Subdivision label for Spain',
  },
  canton: {
    defaultMessage: 'Canton',
    id: 'F5ZVlWcNpb',
    description: 'Subdivision label: canton (e.g. Luxembourg, Switzerland)',
  },
  cantonEntity: {
    defaultMessage: 'Canton / Entity',
    id: 'fyuh+mwfFX',
    description: 'Subdivision label for Bosnia and Herzegovina',
  },
  county: {
    defaultMessage: 'County',
    id: 'avQcNUp9ZO',
    description:
      'Subdivision label: county (e.g. Ireland, Kenya, Croatia, Norway, Sweden)',
  },
  countyNation: {
    defaultMessage: 'County / Nation',
    id: 'gxSbPfTOuG',
    description: 'Subdivision label for the United Kingdom',
  },
  countySpecialMunicipality: {
    defaultMessage: 'County / Special Municipality',
    id: 'URsarnyhn0',
    description: 'Subdivision label for Taiwan',
  },
  department: {
    defaultMessage: 'Department',
    id: 'NHWHuOdlWw',
    description: 'Subdivision label: department (e.g. Benin, Colombia, France)',
  },
  district: {
    defaultMessage: 'District',
    id: 'ZfIEjWInhB',
    description: 'Subdivision label: district (e.g. Bahamas, Belize, Israel, Serbia)',
  },
  districtRegion: {
    defaultMessage: 'District / Region',
    id: '/tdsG7M0DU',
    description: "Subdivision label (e.g. Côte d'Ivoire, Portugal)",
  },
  division: {
    defaultMessage: 'Division',
    id: 'FtbSN18HwP',
    description: 'Subdivision label: division (e.g. Bangladesh, Fiji, Gambia)',
  },
  emirate: {
    defaultMessage: 'Emirate',
    id: 'yHgybUjL3H',
    description: 'Subdivision label for the United Arab Emirates',
  },
  federalMemberState: {
    defaultMessage: 'Federal Member State',
    id: 'Lnxe8/sqY5',
    description: 'Subdivision label for Somalia',
  },
  federalSubject: {
    defaultMessage: 'Federal Subject',
    id: 'vf6jpC4WSZ',
    description: 'Subdivision label for Russia',
  },
  governorate: {
    defaultMessage: 'Governorate',
    id: '2OLJP6z8cl',
    description: 'Subdivision label: governorate (e.g. Bahrain, Egypt, Iraq, Tunisia)',
  },
  island: {
    defaultMessage: 'Island',
    id: 'BwIgZokhvy',
    description: 'Subdivision label: island (e.g. Comoros, Tuvalu)',
  },
  islandGroup: {
    defaultMessage: 'Island Group',
    id: 'v8ovxuV3/e',
    description: 'Subdivision label for Kiribati',
  },
  municipality: {
    defaultMessage: 'Municipality',
    id: '6st0/rCF4V',
    description:
      'Subdivision label: municipality (e.g. Kosovo, Latvia, Montenegro, Qatar)',
  },
  oblast: {
    defaultMessage: 'Oblast',
    id: 'fnosbiKlUa',
    description: 'Subdivision label: oblast (e.g. Belarus, Ukraine)',
  },
  parish: {
    defaultMessage: 'Parish',
    id: 'a1xFOlFVrx',
    description: 'Subdivision label: parish (e.g. Barbados, Grenada, Jamaica, Andorra)',
  },
  prefecture: {
    defaultMessage: 'Prefecture',
    id: '0w2R4toKOx',
    description: 'Subdivision label: prefecture (e.g. Japan, Central African Republic)',
  },
  province: {
    defaultMessage: 'Province',
    id: 'ndKkNEnBNe',
    description:
      'Subdivision label: province (e.g. Angola, Argentina, Canada, Indonesia)',
  },
  provinceDistrict: {
    defaultMessage: 'Province / District',
    id: '+04qPt45zw',
    description: 'Subdivision label for Sierra Leone',
  },
  provinceMunicipality: {
    defaultMessage: 'Province / Municipality',
    id: 'af3PwDYGsf',
    description: 'Subdivision label (e.g. China, Vietnam)',
  },
  provinceRegion: {
    defaultMessage: 'Province / Region',
    id: '3Qbtz6DgMm',
    description: 'Subdivision label for Belgium',
  },
  provinceTerritories: {
    defaultMessage: 'Province / Territory',
    id: '+GSBpscTQW',
    description: 'Subdivision label (e.g. Canada, Pakistan)',
  },
  quarter: {
    defaultMessage: 'Quarter',
    id: 'YZcwYMz/mR',
    description: 'Subdivision label: quarter (e.g. Saint Lucia, Monaco)',
  },
  region: {
    defaultMessage: 'Region',
    id: 'Q62io5PRSR',
    description:
      'Subdivision label: region (e.g. Cameroon, Chile, Finland, Ghana, Italy)',
  },
  regionDepartment: {
    defaultMessage: 'Region / Department',
    id: '4a2BTo22sk',
    description: 'Subdivision label for France',
  },
  regionDistrict: {
    defaultMessage: 'Region / District',
    id: 'UgBYXZHS/q',
    description: 'Subdivision label for Malawi',
  },
  regionState: {
    defaultMessage: 'Region / State',
    id: 'B6F33SgULK',
    description: 'Subdivision label for Myanmar',
  },
  state: {
    defaultMessage: 'State',
    id: 'sASmus00UR',
    description:
      'Subdivision label: state (e.g. United States, Australia, Brazil, Germany)',
  },
  stateFederalTerritory: {
    defaultMessage: 'State / Federal Territory',
    id: 'cK0LzNxNXw',
    description: 'Subdivision label for Malaysia',
  },
  stateTerritory: {
    defaultMessage: 'State / Territory',
    id: 'qaokp/AmoZ',
    description: 'Subdivision label for Australia',
  },
  stateUnionTerritory: {
    defaultMessage: 'State / Union Territory',
    id: 'D/GRSO4HPg',
    description: 'Subdivision label for India',
  },
  statisticalRegion: {
    defaultMessage: 'Statistical Region',
    id: 'wrCQS24qwt',
    description: 'Subdivision label for Slovenia',
  },
  voivodeship: {
    defaultMessage: 'Voivodeship',
    id: 'FMQHf6BW7p',
    description: 'Subdivision label for Poland',
  },
});
